import * as React from 'react';
import FAIcon from '../fAIcon/FAIcon';
import './Paging.css';

interface PagingProps {
    pageSize: number;
    offset: number;
    totalCount: number;
    changeValue: (fieldName: string, value: string | boolean | number, reload: boolean, resetPaging: boolean) => void;
}

export default class Paging extends React.PureComponent<PagingProps> {
    private inputRef = React.createRef<HTMLInputElement>();
   
    public componentDidUpdate(prevProps: PagingProps) {        
        if (this.props.offset !== prevProps.offset) {
            if (this.inputRef.current) {
                const pageNumber = (Math.floor(this.props.offset / this.props.pageSize)) + 1;
                this.inputRef.current.value = pageNumber.toString();
            }
        }
    }

    public render() {        
        const { pageSize, offset, totalCount } = this.props;
        const isFirstPage = offset < pageSize;
        const isLastPage = offset + pageSize >= totalCount;
        const pageNumber = (Math.floor(this.props.offset / this.props.pageSize)) + 1;
        const lastPage = Math.ceil(totalCount / pageSize);
        
        if (totalCount < pageSize) {
            return null;
        }
        return (
            <div className="listNavigation mt-5">
                <button
                    disabled={isFirstPage}
                    className="btn btn-primary align-middle navButton"
                    onClick={this.prevPage}
                >
                    <FAIcon icon="arrow-left" />
                </button>
                <span className="ml-3 mr-3">
                    <input
                        ref={this.inputRef}
                        maxLength={5}
                        className="mr-2"
                        onKeyPress={this.onEnterSend}
                        defaultValue={pageNumber.toString()}
                    />
                    /<label className="ml-2 endPage">{lastPage}</label>
                </span>
                <button
                    disabled={isLastPage}
                    className="btn btn-primary align-middle navButton"
                    onClick={this.nextPage}
                >
                    <FAIcon icon="arrow-right" />
                </button>
            </div>
        );
    }

    private onEnterSend = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            // @ts-ignore not sure why this is illegal, e.currentTarget.value is correct
            let chosenPageNumber = Number.parseInt(e.currentTarget.value, 10);

            const { pageSize, totalCount } = this.props;
            const lastPage = Math.ceil(totalCount / pageSize);

            if (chosenPageNumber < 1) {
                chosenPageNumber = 1;
            }
            if (chosenPageNumber > lastPage) {
                chosenPageNumber = lastPage;
            }

            this.props.changeValue('Offset', (chosenPageNumber - 1) * pageSize, true, false);
            if (this.inputRef.current) {
                this.inputRef.current.value = `${chosenPageNumber}`;
            }
        }
    };

    private prevPage = () => {
        this.props.changeValue('Offset', Math.max(this.props.offset - this.props.pageSize, 0), true, false);
        if (this.inputRef.current) {
            this.inputRef.current.value = `${Math.floor(this.props.offset / this.props.pageSize)}`;
        }
    };

    private nextPage = () => {
        const lastPageOffset = Math.floor(this.props.totalCount / this.props.pageSize) * this.props.pageSize;
        this.props.changeValue('Offset', Math.min(this.props.offset + this.props.pageSize, lastPageOffset), true, false);
        if (this.inputRef.current) {
            this.inputRef.current.value = `${Math.floor(this.props.offset / this.props.pageSize) + 2}`;
        }
    };
}



// WEBPACK FOOTER //
// ./src/components/paging/Paging.tsx